export default __webpack_public_path__ + "static/PromptIconFive-770dfffb0db90d31aae6201f53a1e5ed.png";